module.exports = __webpack_public_path__ + "media/images/emblems/Bister-01ae38f059d301a6f7107e38a165e4f7.png";